module.exports = __webpack_public_path__ + "static/media/received.3f574f4a.svg";